<template>
  <div>
    <form
      class="tw-w-full md:tw-w-4/5 tw-mx-auto tw-rounded tw-overflow-hidden tw-shadow-lg tw-mt-12 tw-p-8 tw-text-left"
    >
      <p class="tw-font-semibold tw-text-xl tw-tracking-tight tw-text-center">
        Enter your project details
      </p>
      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          1. Project Details
        </p>
        <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="title"
              >
                Project Name
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="title"
                type="text"
                placeholder="e.g Solar Panel"
                v-model="data.name"
              />
              <p v-if="errors.name" class="tw-text-xs tw-text-red-500">
                Please enter a project name
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="title"
              >
                Project Sector
              </label>
              <div class="tw-relative">
                <select
                  class="tw-block tw-appearance-none tw-w-full tw-bg-gray-200 tw-border tw-border-gray-200 tw-text-gray-700 tw-py-3 tw-px-4 tw-pr-8 tw-rounded tw-leading-tight focus:tw-outline-none focus:tw-border-gray-500"
                  id="grid-state"
                  v-model="data.sector"
                >
                  <option disabled value="undefined">Select an option</option>
                  <option value="Energy">Energy</option>
                  <option value="Solid Waste">Solid Waste</option>
                  <option value="Transportation">Transportation</option>
                  <option value="Technology">Technology</option>
                  <option value="Buildings">Buildings</option>
                  <option value="Agriculture and Forestry (REDD)">
                    Agriculture and Forestry (REDD)
                  </option>
                </select>
                <div
                  class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
              <p v-if="errors.sector" class="tw-text-xs tw-text-red-500">
                Please select project sector
              </p>
            </div>
          </div>

          <div class="tw-w-full tw-mb-6 md:tw-mb-0">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="title"
            >
              Project Address
            </label>
            <input
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
              id="title"
              type="text"
              placeholder="e.g 234 Herbert Maculey Way Yaba"
              v-model="data.address"
            />
          </div>
          <p v-if="errors.address" class="tw-text-xs tw-text-red-500">
            Please enter a project address
          </p>

          <div class="tw-w-full tw-mb-6 md:tw-mb-0">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="description"
            >
              Project Description(Max 800 words)
            </label>
            <textarea
              class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
              id="description"
              type="text"
              placeholder="Provide a succint description of your idea"
              v-model="data.description"
            />
          </div>
          <p v-if="errors.description" class="tw-text-xs tw-text-red-500">
            Please enter description
          </p>
          <p v-if="errors.description2" class="tw-text-xs tw-text-red-500">
            Description cannot be more than 800 words
          </p>
        </div>
      </div>
      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          2 . Verification Details
        </p>
        <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-8">
          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="date"
              >
                Please enter verification date
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="date"
                type="date"
                v-model="data.verification_date"
              />
              <p
                v-if="errors.verification_date"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter verification date
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="verification_number"
              >
                Please enter verification number
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="verification_number"
                type="text"
                placeholder="e.g 7647"
                v-model="data.verification_number"
              />
              <p
                v-if="errors.verification_number"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter verification number
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="validated_by"
              >
                Project Validator
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="validated_by"
                type="text"
                placeholder="e.g Jane Doe"
                v-model="data.validated_by"
              />
              <p v-if="errors.validated_by" class="tw-text-xs tw-text-red-500">
                Please enter the details of who validated the project
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="validation_number"
              >
                Please enter validation number
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="validation_number"
                type="text"
                placeholder="e.g 8543"
                v-model="data.validation_number"
              />
              <p
                v-if="errors.validation_number"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter verification number
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="validated_by"
              >
                Project Verifier
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="validated_by"
                type="text"
                placeholder="e.g Jane Doe"
                v-model="data.verified_by"
              />
              <p v-if="errors.verified_by" class="tw-text-xs tw-text-red-500">
                Please enter the details of who verified the project
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="validated_by"
              >
                Project Approver
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="validated_by"
                type="text"
                placeholder="e.g Jane Doe"
                v-model="data.approved_by"
              />
              <p v-if="errors.approved_by" class="tw-text-xs tw-text-red-500">
                Please enter the details of who approved the project
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          3. Certification Details
        </p>
        <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6 tw-mt-2">
          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="certified_by"
              >
                Who certified the project
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="certified_by"
                type="text"
                placeholder="e.g Jane Doe"
                v-model="data.certified_by"
              />
              <p v-if="errors.certified_by" class="tw-text-xs tw-text-red-500">
                Please enter the details of who certified the project
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="certified_number"
              >
                Enter the certification number
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="certified_number"
                type="text"
                placeholder="e.g 9484"
                v-model="data.certified_number"
              />
              <p
                v-if="errors.certified_number"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter the certification number of the project
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="certified_date"
              >
                Enter the certification date
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="certified_date"
                type="date"
                v-model="data.certified_date"
              />
              <p
                v-if="errors.certified_date"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter the date of certification of the project
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="life_cycle"
              >
                What is the project life_cycle
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="life_cycle"
                type="text"
                placeholder="e.g 1 year"
                v-model="data.life_cycle"
              />
              <p v-if="errors.life_cycle" class="tw-text-xs tw-text-red-500">
                Please enter the project life_cycle
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="carbon_reduction_capacity"
              >
                Carbon reduction capacity
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="carbon_reduction_capacity"
                type="number"
                placeholder="e.g 500"
                v-model="data.carbon_reduction_capacity"
              />
              <p
                v-if="errors.carbon_reduction_capacity"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter the carbon reduction capacity
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="carbon_balance"
              >
                Carbon balance
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="carbon_balance"
                type="number"
                placeholder="e.g 1000"
                v-model="data.carbon_balance"
              />
              <p
                v-if="errors.carbon_balance"
                class="tw-text-xs tw-text-red-500"
              >
                Please enter the carbon balance
              </p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-1/3 tw-mb-6 md:tw-mb-0">
            <div class="tw-mx-3">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="price"
              >
                Price
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="price"
                type="number"
                placeholder="e.g 5000"
                v-model="data.price"
              />
              <p v-if="errors.price" class="tw-text-xs tw-text-red-500">
                Please enter price
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-rounded tw-overflow-hidden tw-mt-4 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          4. Upload Documents
        </p>
        <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-2">
          <div class="tw-w-full tw-px-3 tw-mb-6 md:tw-mb-0">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="file"
            >
              Please upload the Monitoring Verification Report of your project
            </label>
            <input
              required
              class="tw-py-2 tw-px-4"
              type="file"
              placeholder="90210"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </div>
        </div>

        <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-2">
          <div class="tw-w-full tw-px-3 tw-mb-6 md:tw-mb-0">
            <label
              class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
              for="file"
            >
              Upload image of facility
            </label>
            <input
              required
              multiple
              class="tw-py-2 tw-px-4"
              type="file"
              placeholder="90210"
              id="file"
              ref="files"
              @change="selectFile"
            />
          </div>
          <div>
            <p v-for="(file, index) in files" :key="index">
              {{ file.name }}
            </p>
          </div>
        </div>
      </div>

      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />

      <button
        @click.prevent="submit"
        class="tw-bg-eko-light hover:tw-bg-eko-dark tw-text-white tw-font-bold tw-mt-3 tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
        type="button"
      >
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      user: {},
      token: "",
      data: {},
      errors: {},
      filesUploaded: [],
      loading: false,
      files: [],
      ideas: [],
      file: null,
      id: null,
      company: {},
      res: null,
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    // this.company = JSON.parse(localStorage.getItem("eko-carbon-company"));
    this.getProject();
  },
  methods: {
    getProject() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/project/get/${this.$route.params.id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.data = response.data.project;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          console.log(error);
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    selectFile() {
      const files = this.$refs.files.files[0];
      this.files = [...this.files, files];
      console.log(this.files);
    },
    submit() {
      this.errors = {};
      this.loading = true;
      let deny = false;
      if (!this.data.name) {
        this.errors.name = true;
        deny = true;
      }
      if (!this.data.address) {
        this.errors.address = true;
        deny = true;
      }
      if (!this.data.description) {
        this.errors.description = true;
        deny = true;
      }
      if (this.data.description) {
        if (this.data.description.split(" ").length > 800) {
          this.errors.description2 = true;
          deny = true;
        }
      }
      if (!this.data.sector) {
        this.errors.sector = true;
        deny = true;
      }

      if (!this.data.verification_date) {
        this.errors.verification_date = true;
        deny = true;
      }

      if (!this.data.verified_by) {
        this.errors.verified_by = true;
        deny = true;
      }

      if (!this.data.verification_number) {
        this.errors.verification_number = true;
        deny = true;
      }

      if (!this.data.validated_by) {
        this.errors.validated_by = true;
        deny = true;
      }

      if (!this.data.validation_number) {
        this.errors.validation_number = true;
        deny = true;
      }

      if (!this.data.approved_by) {
        this.errors.approved_by = true;
        deny = true;
      }

      if (deny) {
        this.loading = false;
        return;
      }

      // this.addProject();

      if (!this.file) {
        this.loading = false;
        this.error = true;
        this.$swal(
          "Error!",
          "You need to upload your Monitoring Verification Report",
          "error"
        );
        return;
      }
      this.uploadMVR();

      // if (!this.files) {
      //   this.loading = false;
      //   this.error = true;
      //   this.$swal("Error!", "You need to upload at least one file", "error");
      //   return;
      // }
      // this.uploadImage();
    },

    async uploadMVR() {
      let formData = new FormData();
      this.loading = true;
      formData.append("file", this.file);
      formData.append("upload_preset", "g1bara");
      axios
        .post(
          `https://api.cloudinary.com/v1_1/dldd8ucby/image/upload/`,
          formData
        )
        .then((response) => {
          console.log(response);
          this.data.certification_report = response.data.url;
          this.addProject();
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },

    addProject() {
      this.errors = {};
      const self = this;
      this.data.project_type = "Listing";
      axios
        .post(`${this.$baseUrl}/admin/project/list`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          self.loading = false;
          self.success = true;
          self.data = {};
          self.files = [];
          self.$swal("Success!", "Project added successfully!", "success");
          self.$router.push(`/admin/projects`);
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
